import React, { useEffect, useState } from 'react';

import { useAuth } from '../../../../Auth';
import { useAxios } from '../../../../AxiosHandler';
import { useTranslate } from 'react-polyglot';
import 'react-toastify/dist/ReactToastify.css';
import './BookingBilling.scss';
import Field from '../../../Shared/Wizard/Field/Field';
import { Button, Modal } from 'react-bootstrap';
import moment from "moment";
//import axios from 'axios';
import PageTable from '../../../Shared/PageTable/PageTable';
import './BookingBilling.scss';
import { toast } from 'react-toastify';

interface invoiceRow {
    id: string,
    price: string,
    amount: number,
    firstname: string,
    lastname: string,
    note: string,
    internat: string,
    invo_id: number
}

function BookingBilling(props) {
    const auth = useAuth();
    const axiosHandler = useAxios();
    const axios = axiosHandler.axios;
    const t = useTranslate();

    const [updateTable, setUpdateTable] = useState(0);
    const [deleteInvoice, setDeleteInvoice] = useState({});
    const [approvedInvoice, setApprovedInvoice] = useState({});
    const [downloadInvoice, setDownloadInvoice] = useState({});

    const [showDeleteInvoiceModal, setShowDeleteInvoiceModal] = useState(false);
    const [showApprovedInvoiceModal, setShowApprovedInvoiceModal] = useState(false);
    const [showUndoApprovedInvoiceModal, setShowUndoApprovedInvoiceModal] = useState(false);
    const [showDownloadModal, setShowDownloadModal] = useState(false);
    const [showSendToExternalModal, setShowSendToExternalModal] = useState(false);

    const [showKAAssistModal, setShowKAAssistModal] = useState(false);
    const [kaAssistInvoicerows, setKAAssistInvoicerows] = useState<Array<invoiceRow>>([]);

    const [currentCustomer, setCurrentCustomer] = useState<any>();

    const [canSendOrderFile, setCanSendOrderFile] = useState(100000);
    
    const handleCloseDeleteInvoiceModal = () => setShowDeleteInvoiceModal(false);
    const handleCloseApprovedInvoiceModal = () => setShowApprovedInvoiceModal(false);
    const handleCloseUndoApprovedInvoiceModal = () => setShowUndoApprovedInvoiceModal(false);
    const handleCloseDownloadModal = () => setShowDownloadModal(false);
    const handleCloseSendToExternalModal = () => setShowSendToExternalModal(false);

    const handleShowKAAssistModal = () => {
        setShowKAAssistModal(true);

        axios.single({
            method: "get",
            url: "/api/kaassist/" + props.booking._id,
            data: {},
            responseType: "json",
            headers: {'x-access-token': auth.user["token"]}
        }).then(response => {
            if (response.status === 200) {

                let pricegroups = ResourcesToPricegroups(props.booking.resources);

                setKAAssistInvoicerows(response.data);
            }
        }).catch(err => {
            console.log(err);
        });
    }

    const notifySuccess = (text) => toast(text, {
        position: "bottom-right",
        autoClose: 5000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        className: "success-toast"
    });
    
    const notifyWarning = (text) => toast(text, {
        position: "bottom-right",
        autoClose: 500000,
        hideProgressBar: true,
        closeOnClick: false,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        className: "warning-toast"
    });
    
    function ResourcesToPricegroups(resources) {
        let tmpResources = resources.map(resource=> {
            return {
                keyType: resource["resourceType"],
                keySubtype: resource["resourceSubtype"],
                resource: resource["resource"],
                price: resource["overridePrice"] != undefined ? resource["overridePrice"] : resource["price"],
                unit: resource["unit"],
                amount: sumOfAmount(resource["resource"]).reduce(((accumulator, currentValue) => Number(accumulator) + Number(currentValue)), []),
            } 
        });

        let groups:Array<any> = [];
        tmpResources.forEach(resource => {
            if (groups.some(g => g["keyType"] == resource["keyType"] && g["keySubtype"] == resource["keySubtype"])) {
                let group = groups.find(g => g["keyType"] == resource["keyType"] && g["keySubtype"] == resource["keySubtype"]);
                group.items.push(resource);
            } else {
                groups.push({ keyType: resource["keyType"], keySubtype: resource["keySubtype"], items: [resource] });
            }
        });

        return groups;
    }

    function sumOfAmount(resource){
        let bookingAmount: Array<any> = [];
        let foundResource = props.allResources.find(r=> r._id == resource);
        let bookingResource = props.booking.resources.find(r => r.resource == resource);
        let resourceUnit = bookingResource != undefined ? bookingResource.unit : "";
        if (foundResource != undefined && foundResource.bookings != undefined) { 
            foundResource.bookings.forEach(booking => {
                if (booking.bookingtimes != undefined && booking.bookingId == props.booking._id) {
                    let isSpecific = false;
                    
                    for (let bookingtime of booking.bookingtimes) {
                        if (bookingtime.people != undefined && bookingtime.people.some(p => props.booking.guests.map(g => g._id).includes(p))) {
                            isSpecific = true;
                        }
                    }

                    booking.bookingtimes.forEach(item => {
                        if (isSpecific) {
                            if (item.people != undefined && item.people.some(p => props.booking.guests.map(g => g._id).includes(p))) {
                                let tmpAmount = calculateNumberOfAmount( item.start, item.end, resourceUnit);
                                bookingAmount.push(tmpAmount);
                            }
                        } else {
                            let tmpAmount = calculateNumberOfAmount( item.start, item.end, resourceUnit);
                            bookingAmount.push(tmpAmount);
                        }
                    });
                }
            });
        }
        return bookingAmount;
    }

    const calculateNumberOfAmount = (from, to, unit) =>{
        if(
            from != null &&
            from != undefined &&
            from != "" &&
            to != null &&
            to != undefined &&
            to != ""
        ){
            let timeDiff;

            if(unit == "once"){
                timeDiff = 1;
            } else {
                let tmpArrival = moment(from);
                let tmpDeparture = moment(to);
                let tmpUnit:any = unit+"s";
                if (unit == "day" || unit == "month" || unit == "week") {
                    tmpArrival = tmpArrival.startOf("day");
                    tmpDeparture = tmpDeparture.startOf("day");
                }
                timeDiff = tmpDeparture.diff(tmpArrival, tmpUnit);
                //Math.abs(tmpDeparture.getTime() - tmpArrival.getTime());
                //return Math.ceil(timeDiff / (1000 * 3600 * 24));                 
            }
            return timeDiff ;
        } else {
            return 0;
        }
    }

    const totalPrice = () =>{
        let total: Array<any> = [];
        if(props.booking.resources != undefined){
            ResourcesToPricegroups(props.booking.resources).forEach((item) => {
                let sum = 0;
                item.items.forEach(priceitem => {
                    sum += priceitem.amount * (parseInt(priceitem.price));
                });
                
                if(isNaN(sum)){
                    sum = 0;
                }
                total.push(sum);
            })
        }
        let sumTotal = total.reduce((a, c) => a + c, 0);
        if(isNaN(sumTotal)){
            //notifyWarning(t("booking.resources.missing_price_general"));
            return undefined;
        }
        return sumTotal;
    }
    
    function createInvoice() {
        if(currentCustomer == undefined) {notifyWarning(t("booking.billing.invalid_customer")); return undefined}
        if(currentCustomer.apArNo == undefined || currentCustomer.apArNo == "" ){
            notifyWarning(t("booking.billing.missing_ubw_export"));
        }
        if(currentCustomer.companyRegistrationId != undefined &&currentCustomer.companyRegistrationId != "" ){
            if(
                currentCustomer.apArNo == "" ||
                currentCustomer.organizationName == "" ||
                currentCustomer.companyRegistrationId == "" || 
                //currentCustomer.firstname == "" || 
                //currentCustomer.lastname == "" || 
                currentCustomer.address == "" || 
                currentCustomer.email == "" || 
                //currentCustomer.phone == "" || 
                //currentCustomer.relAttrId == "" ||
                currentCustomer.apArNo == undefined ||
                currentCustomer.organizationName == undefined ||
                currentCustomer.companyRegistrationId == undefined || 
                //currentCustomer.firstname == undefined || 
                //currentCustomer.lastname == undefined || 
                currentCustomer.address == undefined || 
                currentCustomer.email == undefined
                //currentCustomer.phone == undefined
                //currentCustomer.relAttrId == undefined
            ){
                notifyWarning(t("booking.billing.missing_customer_data"));
                return undefined;
            }
        } 
        else {
            if(
                currentCustomer.apArNo == "" ||
                currentCustomer.firstname == "" || 
                currentCustomer.lastname == "" || 
                currentCustomer.address == "" || 
                currentCustomer.email == "" || 
                //currentCustomer.phone == "" || 
                currentCustomer.firstname == undefined || 
                currentCustomer.lastname == undefined || 
                currentCustomer.address == undefined || 
                currentCustomer.email == undefined
                //currentCustomer.phone == undefined  
               
            ){
                notifyWarning(t("booking.billing.missing_customer_data"));
                return undefined;
            }
        }
        
        axios.post(
            "/api/invoicing/", 
            {
                id: props.booking._id
            }, {
                headers: { 'x-access-token': auth.user["token"] }
            }
        ).then(res => {
            setUpdateTable(updateTable + 1);
        });
    }

    const handleShowDeleteInvoiceModal = (dataLine, evt) => {
        evt.stopPropagation();
        evt.nativeEvent.stopImmediatePropagation();
        setDeleteInvoice(dataLine);
        setShowDeleteInvoiceModal(true);
    }

    const handleShowApprovedInvoiceModal = (dataLine, evt) => {
        evt.stopPropagation();
        evt.nativeEvent.stopImmediatePropagation();
        setDownloadInvoice(dataLine);
        setApprovedInvoice(dataLine);
        setShowApprovedInvoiceModal(true);
    }

    const handleShowUndoApprovedInvoiceModal = (dataLine, evt) => {
        evt.stopPropagation();
        evt.nativeEvent.stopImmediatePropagation();
        setApprovedInvoice(dataLine);
        setShowUndoApprovedInvoiceModal(true);
    }

    const handleShowSendToExternalPartner = (dataLine, evt) => {
        evt.stopPropagation();
        evt.nativeEvent.stopImmediatePropagation();
        setDownloadInvoice(dataLine);
        setShowSendToExternalModal(true);
    }
    
    const handleShowDownloadModal = (dataLine, evt) => {
        setDownloadInvoice(dataLine);
        setShowDownloadModal(true);
    }

    function handleDeleteInvoice(){
        axios.delete(
            "/api/invoicing",
            {
                bookingid: props.booking._id,
                orderFileId: deleteInvoice["_id"],
            },
            {
                headers: { 'x-access-token': auth.user["token"] }
            }
        ).then(res => {
            handleCloseDeleteInvoiceModal();
            setUpdateTable(updateTable + 1);
        });
    }

    function handleApprovedInvoice(){ 
        axios.put(
            "/api/invoicing/approvedInvoice/" + props.booking._id,
            {
                id: props.booking._id,
                fileid: approvedInvoice["_id"]
            }, {
                headers: { 'x-access-token': auth.user["token"] }
            }
        ).then(res => {
            handleCloseApprovedInvoiceModal();
            handleSendInvoice();
            setUpdateTable(updateTable + 1);
            props.onChange({ ...props.booking, invoices: res.data.invoices });
            props.onChange({ ...props.booking, status: res.data.status });
        });
    }

    function handleUndoApprovedInvoice() {
        axios.put(
            "/api/invoicing/undoApprovedInvoice/" + props.booking._id,
            {
                id: props.booking._id,
                fileid: approvedInvoice["_id"]
            }, {
                headers: { 'x-access-token': auth.user["token"] }
            }
        ).then(res => {
            handleCloseUndoApprovedInvoiceModal();
            setUpdateTable(updateTable + 1);
            props.onChange({ ...props.booking, status: res.data });
        });
    }

    async function createDownloadFiles(file, fileName, fileType){
        return new Promise((resolve, reject) => {
            const blob = new Blob( [file], { type: 'text/plain' } );
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.style.display = 'none';
            a.href = url;
            // the filename you want
            a.download = fileName + "." + fileType;
            document.body.appendChild(a);
            a.click();
            window.URL.revokeObjectURL(url);
            resolve(file);
        });
    }

    async function handleDownloadInvoice() {
        return new Promise((resolve, reject) => {
            axios.post(
                "/api/invoicing/downloadOrderFile/",
                {
                    bookingId: props.booking._id,
                    orderFileId: downloadInvoice["_id"] 
                }, {
                    headers: { 'x-access-token': auth.user["token"] }
                }
            ).then(res => {
                createDownloadFiles(res.data.file, res.data.filename, res.data.filetype).then(file => {
                    resolve(file);
                });
            });
        });
    }
    
    function handleSendInvoice(){
        axios.all([
            axios.single({
                method: "post",
                url: "/api/invoicing/sendOrderFileExternal/",
                data: {
                  bookingId: props.booking._id,
                  orderFileId: downloadInvoice["_id"] 
                },
                responseType: "json",
                headers: {'x-access-token': auth.user["token"]}
            }),
        ])
        .then(axios.spread((...res) => {
            notifySuccess(t("booking.billing.send_success"));
            setShowSendToExternalModal(false);
            setUpdateTable(updateTable + 1);
        }))
        .catch(err => {
            console.log(err.message);
            
            if(err.message == "Request failed with status code 403"){
                notifyWarning(t("booking.billing.send_failure"));
            }
            setShowSendToExternalModal(false);
            setUpdateTable(updateTable + 1);
        });
        
    }
    
    function handleExportKAAssist(){
        axios.single({
            method: "post",
            url: "/api/kaassist/",
            responseType: "json",
            data: {
                data: kaAssistInvoicerows
            },
            headers: {'x-access-token': auth.user["token"]}
        }).then(res => {
            //console.log(res);
        }).catch(err => {
            console.log(err);
        });
    }
    
    function checkFields(): boolean {
        if(props.booking.customerId == undefined || props.booking.customerId == ""
            /* || props.booking.organization == undefined || props.booking.organization == ""
            || props.booking.companyRegistrationId == undefined || props.booking.companyRegistrationId == ""
            || props.booking.address == undefined || props.booking.address == ""
            || props.booking.postcode == undefined || props.booking.postcode == ""
            || props.booking.city == undefined || props.booking.city == ""
            || props.booking.firstname == undefined || props.booking.firstname == ""
            || props.booking.lastname == undefined || props.booking.lastname == "" */){
                return true;  
            } else {
                return false;
            }  
    }
    
    function getCustomer(){
        axios.all([
            axios.single({
                method: "get",
                url: "/api/customers/"+props.booking.customerId,
                responseType: "json",
                headers: {'x-access-token': auth.user["token"]}
            })
        ])
        .then(axios.spread((...res) => {
            setCurrentCustomer(res[0].data);
        }))
        .catch(err => {
        });
    }
    
    function checkCanSendOrderFile(){
        axios.all([
            axios.single({
                method: "get",
                url: "/api/invoicing/canSendOrderFile",
                responseType: "json",
                headers: {'x-access-token': auth.user["token"]}
            })
        ])
        .then(axios.spread((...res) => {
            setCanSendOrderFile(res[0].data);
        }))
        .catch(err => {
            console.log(err);
        });
    }
    
    useEffect(() => {
        if(props.booking.customerId != undefined){
            getCustomer();
        }
        checkCanSendOrderFile();
    }, [props.booking, props.booking.customerId]);

    return (
        <div style={{ marginTop: '20px' }}>
            <div className="printonly">
                <h3>{t("booking.general.title_contactinformation")}</h3>
                <div className="row">
                    <div className="col col-sm-6">
                        <Field
                            type="dateselector"
                            title={t("booking.general.arrivaldate")}
                            value={props.booking.arrivaldate != undefined && props.booking.arrivaldate != null ? new Date(props.booking.arrivaldate) : undefined}
                            disabled={true}
                        ></Field>
                    </div>
                    <div className="col col-sm-6">
                        <Field
                            type="dateselector"
                            title={t("booking.general.departuredate")}
                            value={props.booking.departuredate != undefined && props.booking.departuredate != null ? new Date(props.booking.departuredate) : undefined}
                            disabled={true}
                        ></Field>
                    </div>
                </div>
                <div className="row">
                    <div className="col col-sm-12">
                        <Field
                            type="input"
                            title={t("booking.general.organization")}
                            value={props.booking.organization != undefined ? props.booking.organization :"" }
                            disabled={true}
                        ></Field>
                    </div>
                    <div className="col col-sm-6">
                        <Field
                            type="input"
                            title={t("booking.general.lastname")}
                            value={props.booking.lastname != undefined ? props.booking.lastname :"" }
                            disabled={true}
                        ></Field>
                    </div>
                    <div className="col col-sm-6">
                        <Field
                            type="input"
                            title={t("booking.general.firstname")}
                            value={props.booking.firstname != undefined ? props.booking.firstname :"" }
                            disabled={true}
                        ></Field>
                    </div>
                </div>
                <hr />
            </div>
            <h3>{t("booking.billing.title_prices")}</h3>
            <div>
                { props.booking.resources != undefined ? ResourcesToPricegroups(props.booking.resources).map((item, itemKey) =>
                    <table key={itemKey} style={{width: "100%"}} className="table table-striped table-bordered invoicetable">
                        <thead>
                            <tr>
                                <th>{(((props.allResourceTypes.find(i => i["_id"] == item["keyType"]) || { name: "" }) as any)["name"]) + "/" + (item["keySubtype"])}</th>
                                <th>{t("booking.billing.unit")}</th>
                                <th>{t("booking.billing.amount")}</th>
                                <th>{t("booking.billing.unitprice")}</th>
                                <th>{t("booking.billing.sumofrow")}</th>

                            </tr>
                        </thead>
                        <tbody> 
                            {item.items.map((i,key) => 
                                <tr key={key}>
                                    <td>{(((props.allResources.find(resource => resource["_id"] == i["resource"]) || { name: "" }) as any)["name"])}</td>
                                    <td style={{width: "100px"}}>{t("general.unit.unittype." + i["unit"])}</td>
                                    <td style={{width: "100px"}}>{i["amount"].length != 0 ? i["amount"] : "N/A"}</td>
                                    <td style={{width: "100px"}}>{i["amount"].length != 0 ? (Number(i["overridePrice"] != undefined ? i["overridePrice"] : i["price"])) : 0}</td>
                                    <td style={{width: "100px"}}>{i["amount"].length != 0 ? (Number(i["overridePrice"] != undefined ? i["overridePrice"] * i["amount"] : i["price"] * i["amount"])) : 0
                                    }
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table> 
                ): null }
                <div style={{width: "100%", overflow: "auto"}} >
                    <div style={{float: "right"}}>
                        <Field
                            type="input"
                            title={t("booking.billing.total")}
                            value={totalPrice()}
                            disabled={true}
                        ></Field>
                    </div>
                </div>
                <Button className="no-print" onClick={ () => window.print() } >
                    {t("booking.billing.print")}
                </Button>
                <br /> <br />
                <Button className="no-print" onClick={() => handleShowKAAssistModal()} >
                    {t("booking.billing.kaassist.startbtn")}
                </Button>
                <br /> <br />
                {props.booking.status != "invoiced" ?
                    <Button className="no-print" onClick={createInvoice} disabled={checkFields()}>{t("booking.billing.invoice")}</Button>
                : null}
                {checkFields() == true ? <p>{t("booking.billing.disabled_invoice_info")}</p> : null}
                
            </div>

            <div className="no-print">
                {props.booking._id != undefined ? 
                    <PageTable
                        dataUrl={"/api/invoicing/getAllPaged/byBooking/" + props.booking._id}
                        options={{
                            showFields: [
                                { label: "Fil", field: "filename" },
                            ]
                        }}
                        dataAfter={(dataLine) =>auth.user["userdata"]["role"] == "Admin" ?
                            <div className="bookingBillingPageTableBtnDiv">
                                {props.booking.status == "invoiced" ? 
                                    dataLine.accepted == true 
                                    ?   <div>
                                            <Button onClick={(evt) => handleShowUndoApprovedInvoiceModal(dataLine, evt)}>{t("booking.billing.undo_approved_invoice")}</Button>
                                            <Button disabled={canSendOrderFile > 0} onClick={(evt) => handleShowSendToExternalPartner(dataLine, evt)}>{canSendOrderFile == 0 ? t("booking.billing.send_to_external") : "Tilgjengelig om " + canSendOrderFile + " sekunder"}</Button>
                                        </div> 
                                    :   <div>
                                            <Button onClick={(evt) => handleShowDeleteInvoiceModal(dataLine, evt)}> {t("booking.billing.delete_invoice")} </Button>
                                        </div>

                                :   <div>
                                        <Button onClick={(evt) => handleShowDeleteInvoiceModal(dataLine, evt)}> {t("booking.billing.delete_invoice")} </Button>
                                        <Button onClick={(evt) => handleShowApprovedInvoiceModal(dataLine, evt)}>{t("booking.billing.approve_invoice")}</Button>
                                    </div>
                                }   
                            </div> 
                        : null} 
                        onLineClick={handleShowDownloadModal}
                        hidePagination={false}
                        hidePagesize={false}
                        hideFilter={false}
                        updateTable={updateTable}
                        hover={true}
                    />
                : null}
            </div>

            {/* Delete modal */}
            <Modal show={showDeleteInvoiceModal} onHide={handleCloseDeleteInvoiceModal}>
                <Modal.Header closeButton>
                    <Modal.Title>
                    {t("booking.billing.delete_invoice")} 
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <p>{t("booking.billing.delete_info")}</p>
                </Modal.Body>
                <Modal.Footer>
                    <Button onClick={handleCloseDeleteInvoiceModal}>{t("booking.billing.cancel")}</Button>
                    <Button onClick={handleDeleteInvoice}> {t("booking.billing.delete_invoice")} </Button>
                </Modal.Footer>
            </Modal>

            {/* Approve modal */}

            <Modal show={showApprovedInvoiceModal} onHide={handleCloseApprovedInvoiceModal}>
                <Modal.Header closeButton>
                    <Modal.Title>
                    {t("booking.billing.approve_invoice")} 
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <p>{t("booking.billing.approve_info")}</p>
                </Modal.Body>
                <Modal.Footer>
                    <Button onClick={handleCloseApprovedInvoiceModal}>{t("booking.billing.cancel")}</Button>
                    <Button onClick={handleApprovedInvoice}> {t("booking.billing.approve_invoice")} </Button>
                </Modal.Footer>
            </Modal>

            {/* Undo approved invoice modal */}

            <Modal show={showUndoApprovedInvoiceModal} onHide={handleCloseUndoApprovedInvoiceModal}>
                <Modal.Header closeButton>
                    <Modal.Title>
                    {t("booking.billing.undo_approved_invoice")} 
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <p>{t("booking.billing.undo_approved_info")}</p>
                </Modal.Body>
                <Modal.Footer>
                    <Button onClick={handleCloseUndoApprovedInvoiceModal}>{t("booking.billing.cancel")}</Button>
                    <Button onClick={handleUndoApprovedInvoice}> {t("booking.billing.undo_approved_invoice")}</Button>
                </Modal.Footer>
            </Modal>


            {/* Download invoice modal */}

            <Modal show={showDownloadModal} onHide={handleCloseDownloadModal}>
                <Modal.Header closeButton>
                    <Modal.Title>
                    {t("booking.billing.download_invoice")}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <p>{t("booking.billing.download_invoice_info")}</p>
                </Modal.Body>
                <Modal.Footer>
                    <Button onClick={handleCloseDownloadModal}>{t("booking.billing.cancel")}</Button>
                    <Button onClick={handleDownloadInvoice}> {t("booking.billing.download_invoice")}</Button>
                </Modal.Footer>
            </Modal>
            
            {/* send invoice modal */}

            <Modal show={showSendToExternalModal} onHide={handleCloseSendToExternalModal}>
                <Modal.Header closeButton>
                    <Modal.Title>
                    {t("booking.billing.send_invoice")}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <p>{t("booking.billing.send_invoice_info")}</p>
                </Modal.Body>
                <Modal.Footer>
                    <Button onClick={handleCloseSendToExternalModal}>{t("booking.billing.cancel")}</Button>
                    <Button onClick={handleSendInvoice}> {t("booking.billing.send_to_external")}</Button>
                </Modal.Footer>
            </Modal>
            
            {/* Export KAAssist modal */}
            <Modal show={showKAAssistModal} size="xl" onHide={() => setShowKAAssistModal(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>
                        {t("booking.billing.kaassist.title")}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <p>{t("booking.billing.kaassist.exportmodal_info")}</p>
                    <table className="invoicerowtable table table-sm table-striped">
                        <thead>
                            <tr>
                                <th>{t("booking.billing.kaassist.exportmodal_table_invoid")}</th>
                                <th>{t("booking.billing.kaassist.exportmodal_table_name")}</th>
                                <th>{t("booking.billing.kaassist.exportmodal_table_note")}</th>
                                <th>{t("booking.billing.kaassist.exportmodal_table_internat")}</th>
                                <th>{t("booking.billing.kaassist.exportmodal_table_days")}</th>
                                <th>{t("booking.billing.kaassist.exportmodal_table_price")}</th>
                            </tr>
                        </thead>
                        <tbody>
                            { kaAssistInvoicerows.map((row, key) => {
                                return <tr key={key} className="invoicerow">
                                    <td style={{padding: "0px 10px"}}>
                                        <Field
                                            type="input"
                                            value={row.invo_id}
                                            onChange={(val) => {
                                                const newKaAssistInvoicerows = kaAssistInvoicerows.map((r, rownum) => {
                                                    if (key == rownum) {
                                                        return {
                                                            ...r,
                                                            invo_id: val
                                                        }
                                                    }
                                                    return r;
                                                });
                                                setKAAssistInvoicerows(newKaAssistInvoicerows);
                                            }}
                                        ></Field></td>
                                    <td style={{padding: "0px 10px"}}>{row.lastname + ", " + row.firstname}</td>
                                    <td style={{padding: "0px 10px"}}>{row.note}</td>
                                    <td style={{padding: "0px 10px"}}>
                                        <Field
                                            type="input"
                                            value={row.internat}
                                            onChange={(val) => {
                                                const newKaAssistInvoicerows = kaAssistInvoicerows.map((r, rownum) => {
                                                    if (key == rownum) {
                                                        return {
                                                            ...r,
                                                            internat: val
                                                        }
                                                    }
                                                    return r;
                                                });
                                                setKAAssistInvoicerows(newKaAssistInvoicerows);
                                            }}
                                        ></Field>
                                    </td>
                                    <td style={{padding: "0px 10px"}}>
                                        <Field
                                            type="input"
                                            value={row.amount}
                                            onChange={(val) => {
                                                const newKaAssistInvoicerows = kaAssistInvoicerows.map((r, rownum) => {
                                                    if (key == rownum) {
                                                        return {
                                                            ...r,
                                                            amount: val
                                                        }
                                                    }
                                                    return r;
                                                });
                                                setKAAssistInvoicerows(newKaAssistInvoicerows);
                                            }}
                                        ></Field>
                                    </td>
                                    <td style={{padding: "0px 10px"}}>
                                        <Field
                                            type="input"
                                            value={row.price}
                                            onChange={(val) => {
                                                const newKaAssistInvoicerows = kaAssistInvoicerows.map((r, rownum) => {
                                                    if (key == rownum) {
                                                        return {
                                                            ...r,
                                                            price: val
                                                        }
                                                    }
                                                    return r;
                                                });
                                                setKAAssistInvoicerows(newKaAssistInvoicerows);
                                            }}
                                        ></Field>
                                    </td>
                                </tr>
                            })}
                        </tbody>
                    </table>
                </Modal.Body>
                <Modal.Footer>
                    <Button onClick={() => setShowKAAssistModal(false)}>{t("booking.billing.kaassist.cancelbtn")}</Button>
                    <Button onClick={handleExportKAAssist}> {t("booking.billing.kaassist.sendbtn")}</Button>
                </Modal.Footer>
            </Modal>
        </div>
    );
}

export default BookingBilling;